import { configureApiFetch } from '@sizilianer/core/apiFetch';
import { supabase } from '@/lib/supabase';

/**
 * Web-Boot des zentralen API-Clients (Phase 0.7). Als Seiteneffekt-Modul
 * ganz oben in src/main.tsx importiert — die Konfiguration muss stehen,
 * bevor irgendein Feature apiFetch benutzt.
 *
 * baseUrl '' hält alle Web-Aufrufe byte-identisch relativ; die native
 * App konfiguriert hier später die Prod-Origin und ihren eigenen
 * Token-Provider.
 */
configureApiFetch({
  baseUrl: '',
  getToken: async () => {
    const { data } = await supabase.auth.getSession();
    return data.session?.access_token ?? null;
  },
});
